import React from 'react';
import TopBar from '../components/TopBar';
import SafeIcon from '../common/SafeIcon';

export default function Settings() {
  const eqSettings = [
    { label: 'Sub Bass', value: 80, color: 'aqua' },
    { label: 'Bass', value: 65, color: 'aqua' },
    { label: 'Mid', value: 40, color: 'plasma' },
    { label: 'High Mid', value: 70, color: 'plasma' },
    { label: 'Treble', value: 85, color: 'aqua' },
  ];

  return (
    <div className="flex-1 overflow-y-auto w-full h-full bg-mesh-pattern pb-32">
      <TopBar title="System Preferences" />
      <div className="p-6 max-w-4xl mx-auto space-y-8">
        
        {/* Equalizer Section */}
        <section className="glass-panel p-8 rounded-2xl border-t-2 border-t-plasma">
          <div className="flex items-center gap-3 mb-8">
            <SafeIcon icon="FiSliders" className="text-2xl text-plasma" />
            <div>
              <h3 className="text-xl font-display font-bold text-white">Neural Equalizer</h3>
              <p className="text-sm text-gray-400">Calibrate your algorithmic discovery engine.</p>
            </div>
          </div>
          <div className="space-y-6">
            {eqSettings.map((eq) => (
              <div key={eq.label} className="flex items-center gap-4">
                <span className="w-20 text-sm text-gray-400 text-right">{eq.label}</span>
                <div className="flex-1">
                  <input type="range" min="0" max="100" defaultValue={eq.value} className={eq.color === 'plasma' ? 'plasma-thumb' : ''} />
                </div>
                <span className="w-8 text-sm font-display text-white">{eq.value}</span>
              </div>
            ))}
          </div>
        </section>

        {/* Account & Interface Section */}
        <section className="glass-panel p-8 rounded-2xl border-t-2 border-t-aqua">
          <h3 className="text-xl font-display font-bold text-white mb-6 flex items-center gap-2">
            <SafeIcon icon="FiMonitor" className="text-aqua" /> Interface Output
          </h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between p-4 bg-vinyl-900/50 rounded-xl border border-vinyl-700 hover:border-vinyl-500 transition-colors">
              <div>
                <h4 className="text-white font-medium">Holographic Mode</h4>
                <p className="text-xs text-gray-400">Enable advanced UI animations and glows.</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" defaultChecked className="sr-only peer" />
                <div className="w-11 h-6 bg-vinyl-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-aqua glow-aqua"></div>
              </label>
            </div>
            
            <div className="flex items-center justify-between p-4 bg-vinyl-900/50 rounded-xl border border-vinyl-700 hover:border-vinyl-500 transition-colors">
              <div>
                <h4 className="text-white font-medium">Data Sync</h4>
                <p className="text-xs text-gray-400">Share listening history with the neural network.</p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" className="sr-only peer" />
                <div className="w-11 h-6 bg-vinyl-700 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-plasma"></div>
              </label>
            </div>
          </div>
        </section>

        {/* Help & About Section */}
        <section className="grid md:grid-cols-2 gap-8">
          <div className="glass-panel p-6 rounded-2xl flex flex-col justify-between">
            <div>
              <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
                <SafeIcon icon="FiHelpCircle" className="text-gray-400" /> Help & Support
              </h3>
              <p className="text-sm text-gray-400 mb-4">Experiencing node desync or audio latency? Access the developer documentation or contact support.</p>
            </div>
            <button className="w-full py-2 bg-vinyl-800 border border-vinyl-600 rounded-lg text-sm text-white hover:bg-vinyl-700 transition-colors">
              View Documentation
            </button>
          </div>
          
          <div className="glass-panel p-6 rounded-2xl flex flex-col justify-between">
            <div>
              <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
                <SafeIcon icon="FiInfo" className="text-gray-400" /> About SoundNest
              </h3>
              <p className="text-sm text-gray-400 mb-4">Version 2.0.4 - "Neon Symphony"<br/>Engine Status: Optimal</p>
            </div>
            <div className="text-xs text-gray-500 flex items-center justify-between border-t border-vinyl-700 pt-3">
              <span>Terms of Service</span>
              <span>Privacy Policy</span>
            </div>
          </div>
        </section>

        <div className="text-center pt-8 pb-4">
          <p className="text-[10px] text-gray-600 uppercase tracking-widest font-display">
            Made by LingLink AI and DigLab AI
          </p>
        </div>
      </div>
    </div>
  );
}